module.exports = __webpack_public_path__ + "static/media/generic_movers.241a82b3.svg";